<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="20.414" height="17.828" viewBox="0 0 20.414 17.828" v-bind="$attrs">
        <path d="M13.5,4.5,21,12m0,0-7.5,7.5M21,12H3" transform="translate(-2 -3.086)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
    </svg>
</template>
